import styled from 'styled-components';

import { lineClamp } from '@/utils/line-clamp';

export const Link = styled.a`
  color: inherit;

  &:hover {
    text-decoration: none;
  }
`;

export const ProfileInfoTextWrapper = styled.span`
  white-space: normal;
  ${lineClamp(2)}
`;
